import { render, staticRenderFns } from "./DynamicEdit.vue?vue&type=template&id=0beb7e6b&scoped=true&"
import script from "./DynamicEdit.vue?vue&type=script&lang=js&"
export * from "./DynamicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb7e6b",
  null
  
)

export default component.exports